import { Spin } from 'iview'
var DEFAULT_CONFIG = {
  showConfig: {
    render: (h) => {
      return h('div', [
        h('Icon', {
          'class': 'demo-spin-icon-load',
          props: {
            type: 'ios-loading',
            size: 18
          }
        }),
        h('div', '加载中...')
      ])
    }
  }
}
/*
<Spin fix>
                <div class="loader">
                    <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10"></circle>
                    </svg>
                </div>
            </Spin>
console.log(Spin) */
/* let modalInstance

function getModalInstance (options) {
  console.log(Modal)
  modalInstance = modalInstance || Modal.newInstance(Object.assign({}, options, DEFAULT_CONFIG))

  return modalInstance
} */

function show () {
  Spin.show(DEFAULT_CONFIG.showConfig)
}

function hide () {
  Spin.hide()
}

var IviewSpin = {
  show,
  hide
}

export default IviewSpin



// WEBPACK FOOTER //
// ./src/third/Spin.js